import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { Box, Typography } from "@mui/material";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import { ShopCenterPagination } from "../shop/ShopCenterPagination";
import { PendingOrdersList } from "./PendingOrdersList";
import { ListSkeleton } from "../common/Skeletons";
import { EmptyState } from "../common/EmptyState";

import '../../styles/Orders.scss';

import PendingOrdersService from "../../services/pendingOrdersService";
import { Header } from "../common/Header";
import { TopBar } from "../common/TopBar";



/**
 * Renders information about the user obtained from MS Graph
 * @param props 
 */
export const PendingOrders = (props) => {

    let pendingOrdersBase = {
        result: [],
        pages: [],
        totalPages: 0,
        totalCount: 0,
        page: 0,
        pageSize: 30
    };



    const orderService = PendingOrdersService();
    const [orders, setOrders] = useState(pendingOrdersBase);
    const [orderLoaded, setOrderLoaded] = useState(false);
    const [filter, setFilter] = useState({
        page: pendingOrdersBase.page,
        pageSize: pendingOrdersBase.pageSize,
    });

    const [totPages, setTotPages] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(30);

    const [showItem, setShowItem] = useState(false);

    useEffect(() => {

        const initState = async () => {
            setOrderLoaded(false);
            const allOrders = await orderService.getPendingOrders(0, 30);
            setOrders(allOrders);
            pendingOrdersBase = allOrders;
            setTotPages(allOrders.totalPages);
            setPage(allOrders.page);
            setPageSize(allOrders.pageSize);
            setFilter({
                totalCount: allOrders.totalCount,
                totalPages: allOrders.totalPages,
                page: allOrders.page,
                pageSize: allOrders.pageSize,
                pages: allOrders.pages,
            });
            setOrderLoaded(true);
        };
        initState();
    }, []);

    const updateOrders = async (a) => {
        setOrderLoaded(false);
        const page = a - 1;
        console.log("updateOrders", a, page);
        const newOrders = await orderService.getPendingOrders(page, pageSize)
        console.log("newOrders", newOrders);
        setOrders(newOrders);
        pendingOrdersBase = newOrders;
        setTotPages(newOrders.totalPages);
        setPage(newOrders.page);
        setPageSize(newOrders.pageSize);
        setFilter({
            totalCount: orders.totalCount,
            totPages: orders.totalPages,
            page: orders.page,
            pageSize: orders.pageSize,
        });

        setOrderLoaded(true);
        setShowItem(false);
    }

    const onPageChange = (newPage) => {
        if (page != newPage) {
            console.log("onPageChange", newPage, page);
            console.log("showPending", showPending);
            setPage(newPage);

            updateOrders(newPage);
            setShowItem(false);
            setOrderLoaded(true);
        }
    };

    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
            <Header />
            <TopBar />
            <Box sx={{ px: { xs: 2, md: 4 }, py: 3 }}>
                {!showItem && (
                    <Typography variant="h5" align="center" sx={{ fontWeight: 800, mb: 3 }}>
                        Pending Orders
                    </Typography>
                )}
                {!orderLoaded ? (
                    !showItem && <ListSkeleton rows={6} columns={6} />
                ) : (
                    <>
                        {!showItem && orders.totalCount > 0 && (
                            <Container>
                                <Row>
                                    <ShopCenterPagination
                                        totPages={totPages}
                                        currentPage={page}
                                        pageClicked={(ele) => onPageChange(ele)}
                                    />
                                </Row>
                            </Container>
                        )}
                        {orders.totalCount > 0 ? (
                            <PendingOrdersList
                                orders={orders}
                                filter={filter}
                                onPageChange={onPageChange}
                                showItem={showItem}
                                setShowItem={setShowItem}
                            />
                        ) : !showItem ? (
                            <EmptyState
                                icon={<PendingActionsOutlinedIcon />}
                                title="No pending orders"
                                description="Orders you've placed will appear here while they're awaiting processing."
                            />
                        ) : null}
                    </>
                )}
            </Box>
        </Box>
    );
};